import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar } from "antd";

// import DataTable from "./DataTable";

import "../PassportDetails.css";

import BottomNavigationBar from "../BottomNavigation";

import AllowMADINATPTGridFilter from "./AllowMADINATPTGridFilter";

function MADINATPT() {


  return (
    <>
   
    <div className="background-image-allow-transport">
      {/* <div className="dark-overlay"></div> */}

      <MDBContainer breakpoint=" p-4">
        <div className="">
          <div>
            <div
              className="navebar"
              style={{
                background: "",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <img className="logo" src={window.logo} alt="logo" />
              <Avatar
                className="profile"
                alt="Remy Sharp"
                src={window.profile}
              />
            </div>
            <AllowMADINATPTGridFilter />
          </div>
        </div>
      </MDBContainer>

      <div className="bottom-bar-lay">
        <BottomNavigationBar />
      </div>
    </div>
  </>
    
  )
}

export default MADINATPT;